import type { CopyShape } from "../../intl";

import type { FORMAT_LIMIT_COPY_PT_BR } from "../format-limit.copy";

export const FORMAT_LIMIT_COPY_ES_ES: CopyShape<
  typeof FORMAT_LIMIT_COPY_PT_BR
> = {
  disabled: "—",
  included: "incluido",
  unlimited: "ilimitado",
  trialOnly: "en la prueba",
  trialWithLimit: (limit: number): string => `${limit} en la prueba`,
  hours: (stored: number): string => `${stored} h`,
  hoursAsDays: (days: number): string => `${days} días`,
  days: (stored: number): string => `${stored} días`,
  trialDay: "1 día",
  trialDays: (stored: number): string => `${stored} días`,
  interval: (value: string): string => `cada ${value}`,
  monthly: (counted: string): string => `${counted} /mes`,
  total: (counted: string): string => `${counted} en total`,
};
